// AssetsTableHeader.jsx

import AssetsTableHeadCell from "./assets-table-head-cell.jsx";

export default function AssetsTableHeader() {
    return (
        <thead className="border-t border-b border-gray-300">
        <tr>
            <AssetsTableHeadCell>Descrição</AssetsTableHeadCell>
            <AssetsTableHeadCell>Patrimônio</AssetsTableHeadCell>
            <AssetsTableHeadCell>Série</AssetsTableHeadCell>
            <AssetsTableHeadCell>Local</AssetsTableHeadCell>
            <AssetsTableHeadCell>Marca</AssetsTableHeadCell>
            <AssetsTableHeadCell>Modelo</AssetsTableHeadCell>
            <AssetsTableHeadCell>Status</AssetsTableHeadCell>
            <AssetsTableHeadCell>Tipo</AssetsTableHeadCell>
            <AssetsTableHeadCell>Fornecedor</AssetsTableHeadCell>
            <AssetsTableHeadCell>Garantia</AssetsTableHeadCell>
        </tr>
        </thead>
    );
}